<template>
  <ais-instant-search
    :search-client="searchClient"
    :on-state-change="clearFilters"
    :routing="routing"
    :index-name="indexName">
    <SearchResultsPage />
  </ais-instant-search>
</template>

<script>
import Client from '@searchkit/instantsearch-client';
import Searchkit from 'searchkit';
import SearchResultsPage from './search_results_page.vue';
import { history } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';

const ELASTICSEARCH_INDEX_NAME = 'offers-' + process.env.RAILS_ENV + '-v7';

let ELASTICSEARCH_PUBLIC_ENDPOINT = () => {
  if (['development', 'test'].includes(process.env.RAILS_ENV)) {
    return 'http://localhost:9200';
  } else {
    return 'https://d7pi30f5y3.execute-api.ap-southeast-2.amazonaws.com/offers/' + process.env.RAILS_ENV;
  }
};


const config = {
  connection: {
    host: ELASTICSEARCH_PUBLIC_ENDPOINT(),
  },
  search_settings: {
    search_attributes: [
      { field: 'subcategories', weight: 3 },
      { field: 'provider', weight: 3 },
      { field: 'headline', weight: 2 },
      { field: 'keywords', weight: 2 },
      { field: 'category', weight: 2 },
      'detail',
      'addresses',
    ],
    result_attributes: ['headline', 'amount', 'provider', 'provider_image', 'provider_image_url', 'provider_image_description',  'id', 'category_id', 'start_date', 'expiring_offer'],
    sorting: {
      default: [
        {
          field: '_score',
          order: 'desc',
        },
        {
          field: 'start_date',
          order: 'desc',
        },
      ],
    },
    facet_attributes: [
      {
        attribute: 'super_category',
        field: 'super_category.keyword',
        type: 'string',
      },
      { attribute: 'category',
        field: 'category.keyword',
        type: 'string',
      },
      { attribute: 'subcategories',
        field: 'subcategories.keyword',
        type: 'string',
      },
      { attribute: 'region',
        field: 'region.keyword',
        type: 'string',
        filterQuery: (field, value) => {
          if (value === 'All of New Zealand') {
            return {
              match_all: {},
            };
          } else {
            return {
              term: {
                [field]: value,
              },
            };
          }
        },
      },
      { attribute: 'district',
        field: 'district.keyword',
        type: 'string',
      },
      { attribute: 'availability',
        field: 'availability.keyword',
        type: 'string',
      },
      {
        attribute: 'tags',
        field: 'tags.keyword',
        type: 'string',
      },
    ],
    query_rules: [],
  },
};
const searchkitClient = new Searchkit(config);
const searchClient = Client(searchkitClient);

export default {
  name: 'SearchResultsApp',
  components: {
    SearchResultsPage,
  },
  data() {
    return {
      routing: {
        router: history(),
        stateMapping: singleIndexMapping(ELASTICSEARCH_INDEX_NAME),
      },
      indexName: ELASTICSEARCH_INDEX_NAME,
      searchClient,
    };
  },
  methods: {
    clearFilters({ uiState, setUiState}) {
      if (uiState[ELASTICSEARCH_INDEX_NAME]?.menu?.category === undefined) {
        delete uiState[ELASTICSEARCH_INDEX_NAME]?.menu?.subcategories;
      }

      if (uiState[ELASTICSEARCH_INDEX_NAME]?.menu?.region === undefined) {
        delete uiState[ELASTICSEARCH_INDEX_NAME]?.menu?.district;
      }

      setUiState(uiState);
    },
  },
};
</script>
